import { render } from "./SpecialTemplatesMarkets.vue?vue&type=template&id=57ddd48e&scoped=true"
import script from "./SpecialTemplatesMarkets.vue?vue&type=script&lang=js"
export * from "./SpecialTemplatesMarkets.vue?vue&type=script&lang=js"

import "./SpecialTemplatesMarkets.vue?vue&type=style&index=0&id=57ddd48e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ddd48e"]])

export default __exports__